module.exports = __webpack_public_path__ + "media/images/USA-bride-image2-9caa85fd219a90993cc21bef79234641.jpg";